import { connect } from 'react-redux';

import { actions } from 'Data/actions';
import PractitionerLogin from './component';

export default connect(null, (dispatch) => ({
  openTsAndCsModal: () => dispatch(actions.modalOpen({
    id: 'tsAndCs',
  })),
  locationPractitionerDashboard: () => dispatch({
    type: 'PRACTITIONER_DASHBOARD',
  }),
}))(PractitionerLogin);
